<template lang="pug">
  app-modal(
    :titulo="`Visualizar conflito`",
    @closeModal="closeModal()",
    :width="1000",
    :height="700"
    :bodyStyle="{height: 'auto', padding: '0'}"
  )
    template(slot="body")
      div
        el-row(:gutter="20").row-paddin
          el-col.margin-top(:md="12", :sm="24")
            span.info-title Número do Processo:
            span.info-label {{formatLabel(conflito.numeroProcesso)}}
          el-col.margin-top(:md="12", :sm="24")
            span.info-title Nome/Razão Social do Intere:
            span.info-label {{formatLabel(conflito.interessado.nomeRazaoSocial)}}
          el-col.margin-top(:md="12", :sm="24")
            span.info-title CPF/CNPJ do Interessado:
            span.info-label {{formatLabel(conflito.interessado.cpfCnpj)}}
          el-col.margin-top(:md="12", :sm="24")
            span.info-title Município:
            span.info-label {{formatLabel(conflito.municipio ? conflito.municipio.nome : '-')}}
          el-col.margin-top(:md="12", :sm="24")
            span.info-title Número de Famílias:
            span.info-label {{formatLabel(conflito.numeroFamilias)}}
          el-col.margin-top(:md="12", :sm="24")
            span.info-title Jurisdição:
            span.info-label {{formatLabel(conflito.jurisdicaoFormatada)}}
          el-col.margin-top(:md="12", :sm="24")
            span.info-title Data de Cadastro:
            span.info-label {{formatLabel(conflito.dataCriacaoFormatada)}}
          el-col.margin-top(:md="12", :sm="24")
            span.info-title Data de Atualização:
            span.info-label {{formatLabel(conflito.dataCriacaoFormatada)}}
          el-col.margin-top(:md="12", :sm="24")
            span.info-title Origem:
            span.info-label {{formatLabel(conflito.origemFormatada)}}
          el-col.margin-top(:md="12", :sm="24")
            span.info-title Tipo de Processo:
            span.info-label {{formatLabel(conflito.tipoProcesso ? conflito.tipoProcesso.nome : '-')}}
          el-col.margin-top(:md="12", :sm="24")
            span.info-title Status:
            span.info-label {{formatLabel(conflito.statusFormatado)}}
          el-col.margin-top(:md="12", :sm="24")
            span.info-title Área/Imóvel/Comunidade:
            span.info-label {{formatLabel(conflito.areaImovelComunidade)}}
          el-col.margin-top(:md="12", :sm="24")
            span.info-title Setor:
            span.info-label {{formatLabel(conflito.setor)}}
          el-col.margin-top(:md="12", :sm="24")
            span.info-title Possui Georreferenciamento:
            span.info-label {{formatLabel(conflito.possuiGeorreferenciamento ? 'Sim' : 'Não')}}
          el-col.margin-top(:md="12", :sm="24")
            span.info-title Descrição:
            span.info-label {{formatLabel(conflito.descricaoCaso)}}
          el-col.margin-top(:md="12", :sm="24")
            span.info-title Observação:
            span.info-label {{formatLabel(conflito.observacao)}}
          el-col.margin-top(:md="12", :sm="24")
            span.info-title Resposta:
            span.info-label {{formatLabel(conflito.resposta)}}
        el-row(:gutter="20").row-paddin
          el-col(:span="24")
            span.info-title Shape do conflito
          el-col.margin-top(:span="24", v-if="conflito.geometrias && conflito.geometrias.length > 0")
            app-resumo-mapa(
              :idMapa="'id-mapa-localizacao-' + conflito.id"
              :height="30"
              :localizacoes="conflito.geometrias.map(g => JSON.parse(g))",
              :isVisualizarCadastro="true"
            )
            .flex-button
              div.btn
                el-button(
                  @click="downloadShape(conflito.id)"
                )
                  i.fal.fa-download
                  | &nbsp Download do shapefile
          el-col.margin-top(:span="24", v-if="conflito.possuiGeorreferenciamento")
            span.info-title Documentos
            el-table(:data="conflito.documentos", :show-header="false")
              el-table-column(
                prop="nome"
              )
              el-table-column(
                prop="tipo.descricao"
              )
              el-table-column(
                align="right"
                width="110"
              )
                template(slot-scope="scope")
                  el-tooltip.item(
                    effect='dark',
                    content='Baixar arquivo',
                    placement="left"
                  )
                    el-button.button(@click="emitDownload(scope.row)")
                      font-awesome-icon(icon="download", size="lg")

</template>
<script>
import AppModal from '@/components/AppModal'
import axios from '@/utils/api'
import FileSaver from 'file-saver'
import AppResumoMapa from '@/components/resumo/AppResumoMapa'

export default {
  name: 'ModalVisualizarConflito',
  components: {
    AppModal,
    AppResumoMapa
  },
  props: {
    conflito: {
      type: Object,
      required: true
    }
  },

  methods: {
    closeModal () {
      this.$emit('closeModal')
    },
    async downloadShape (id) {
      await axios({
        method: 'GET',
        url: `api/v1/conflitos/shape/exportar/${id}`,
        responseType: 'blob'
      })
    },
    formatLabel (label) {
      return label || '-'
    },
    async emitDownload (documento) {
      const file = await axios({
        method: 'POST',
        url: `documento/file`,
        data: documento,
        responseType: 'blob'
      })
      FileSaver.saveAs(file, documento.nome)
    }
  }
}

</script>
<style lang="scss" scoped>

 .info-title {
    font-size: 14px;
    font-weight: bold;
    margin-right: 5px;
    color: #000;
  }

  .info-label {
    font-size: 14px;
    color: #000;
  }
  .margin-top {
    margin-top: 10px;
  }

  .row-paddin {
    padding: 20px;
  }

  .flex-button {
    display: flex;
    justify-content: end;
    margin-top: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/screens/ouvidoria/components/ModalVisualizarConflito.vue